export const PoliticallyExposedPersonTitle =
	"Politically exposed person (PEP) is a term describing someone who has been entrusted with a prominent public function.";
